import React from "react";
import "../styles.css";

const Entertainment = () => (
  <div className="page-container">
    <h1>Entertainment Bookings</h1>
    <p>Under Construction</p>
  </div>
);

export default Entertainment;
